import { Types } from './song.js'

export const Lists = [
	{ type: Types.LEARNING, color: "YellowGreen", weight: true },
	{ type: Types.DONE, color: "SkyBlue", weight: true },
	{ type: Types.QUEUE, color: "SandyBrown", weight: false },
	{ type: Types.FORGOTTEN, color: "Silver", weight: false },
]

export function type2Style(type) {
	return `background-color: ${Lists.find(v => v.type == type).color}`;
}
